import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import appConfigCoverGoProd from "./appConfigCoverGoProd"
import { COVERGO_ASIA_PROD, COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const asia = {
	// Dev
	"asia-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PRE_PROD },

	// Prod
	"asia-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_ASIA_PROD }
}
